export default __webpack_public_path__ + "static/media/box_left_two_step.5f416787.png";